import bookingRouter from './booking.router';
import bookingComponent from './booking.component';
import bookingService from './booking.service';

import bookingCreateModule from './booking-create/booking-create'
import bookingUpdateModule from './booking-update/booking-update';
import bookingListModule from './booking-list/booking-list';
import bookingMultiModule from './booking-multi/booking-multi';

import {getHumanReadableRoute} from './getHumanReadableRoute.filter';
import {getHumanReadableRouteById} from './getHumanReadableRouteById.filter';
import {getOperator} from './getOperator.filter';
import {isUserHasOperator} from './isUserHasOperator.filter';
import {isSchedule, getScheduleHours} from './schedule';
import {bookingLimitComponent} from "./booking-limit/booking-limit.component";
import agreementsModule from "./agreements/agreements";
import afterhoursModule from "./afterhours/afterhours";
import bookingSpeditorListModule from "./booking-speditor-list/booking-speditor-list";
import bookingManagerListModule from "./booking-manager-list/booking-manager-list";

const BookingModule = angular
	.module('booking', [
		bookingCreateModule.name,
		bookingListModule.name,
		bookingSpeditorListModule.name,
    bookingManagerListModule.name,
		bookingUpdateModule.name,
		bookingMultiModule.name,
		agreementsModule.name,
		afterhoursModule.name,
	])
	.config(bookingRouter)
	.service('$bookings', bookingService)
	.component('booking', bookingComponent)
	.component('bookingLimitComponent', bookingLimitComponent)
	.filter('getHumanReadableRoute', getHumanReadableRoute)
	.filter('getHumanReadableRouteById', getHumanReadableRouteById)
	.filter('getOperator', getOperator)
	.filter('isUserHasOperator', isUserHasOperator)
	.filter('isSchedule', isSchedule)
	.filter('getScheduleHours', getScheduleHours);

export default BookingModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking.js
 **/